import {
  makeStyles,
  TableCell,
  TableCellProps,
  Theme,
} from '@material-ui/core';
import clsx from 'clsx';
import { getCellWidthStyle } from './utils/columnResizingUtils';

const useStyle = makeStyles<Theme>(
  theme => ({
    root: {
      paddingLeft: theme.spacing(0.5),
      paddingRight: theme.spacing(1),
      // In table layout, height is honored more reliably than minHeight on td.
      // This still allows rows to grow when content needs more space.
      height: 38,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      '& p': {
        textOverflow: 'ellipsis',
        display: 'block',
        overflow: 'hidden',
      },
    },
  }),
  { name: 'WbTableCell' },
);

type WbTableCellProps = TableCellProps & { colId: string };

export const WbTableCell: React.FC<WbTableCellProps> = ({
  className,
  colId,
  style,
  ...props
}) => {
  const { root } = useStyle();
  return (
    <TableCell
      size="small"
      className={clsx(root, className)}
      style={{
        ...getCellWidthStyle(colId),
        ...style,
      }}
      {...props}
    />
  );
};
